import "./styles/index.scss";
import App from "./App";
import UserContextProvider from "./context/UserContext";
import { createRoot } from "react-dom/client";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
};

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <UserContextProvider>
    <Provider template={AlertTemplate} {...options}>
      <App />
    </Provider>
  </UserContextProvider>
);
